// extracted by mini-css-extract-plugin
export default {"container":"EventContent_container--yEb","emptyState":"EventContent_emptyState--x8m"};